import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Mail, ArrowLeft, Lock, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Si cette adresse existe, un email a été envoyé');
      if (res.data.debug_token) {
        console.log('Debug reset token:', res.data.debug_token);
      }
    } catch {
      toast.error('Erreur lors de l\'envoi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center px-4">
      <Card className="w-full max-w-md" data-testid="forgot-password-card">
        <CardHeader className="text-center">
          <Link to="/login" className="inline-flex items-center text-sm text-primary mb-4 hover:underline">
            <ArrowLeft className="w-4 h-4 mr-1" /> Retour à la connexion
          </Link>
          <CardTitle className="text-2xl">Mot de passe oublié</CardTitle>
          <p className="text-muted-foreground text-sm mt-2">
            Entrez votre email pour recevoir un lien de réinitialisation
          </p>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="text-center space-y-4 py-4" data-testid="reset-email-sent">
              <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
              <p className="font-medium text-foreground">Email envoyé !</p>
              <p className="text-sm text-muted-foreground">
                Si l'adresse <strong>{email}</strong> est associée à un compte, vous recevrez un lien de réinitialisation.
              </p>
              <p className="text-xs text-muted-foreground italic">
                (Mode démo : consultez la console du navigateur pour le token de debug)
              </p>
              <Button onClick={() => navigate('/login')} variant="outline" className="mt-4">
                Retour à la connexion
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email">Adresse email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-3 w-4 h-4 text-muted-foreground" />
                  <Input
                    id="email" type="email" required
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.com"
                    className="pl-10"
                    data-testid="forgot-email-input"
                  />
                </div>
              </div>
              <Button type="submit" className="w-full btn-primary" disabled={loading} data-testid="forgot-submit-btn">
                {loading ? 'Envoi...' : 'Envoyer le lien'}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
